// @flow
import Availability, { type AvailabilityType } from './availability';

export default Availability;
export type { AvailabilityType };
